window.Automation = {
	editForm : function (linkedtype, linkedid, automationID) {
		automationID = automationID == undefined ? '' : automationID;
		var formID = 'automationForm';
		
		var data = {
			action			: "editForm",
			linkedtype		: linkedtype,
			linkedid		: linkedid,
			automationID	: automationID
		};
		
		var options = {
			title :  automationID == '' ? Loc.g('Création d‘une action automatique') : Loc.g('Modification d‘une action automatique'),
			buttons: [
				{
					"class" : "btn btn-default",
					text: Loc.g("Annuler"), 
					click: function() {
						$(this).dialog("close");
					}
				},
				{
					"class" : "btn btn-primary",
					text: Loc.g("Enregistrer"), 
					click: function() {
						$("#" + formID).submit();
					}
				}
			],
			width: 800,
			callback: function() {
				var options = {
					data : {action : 'record'},
					dataType : 'json',
					success : function(data){
						var formOk = MyForm.processJson(data, formID);
						if(formOk) {
							Utils.relocate(window.location.href.replace('/&tab=automations/ig', '')+'&tab=automations');
						}
					}
				};
				
				MyForm.prepare(formID, 'automation', options, true);
				MyFacture.customForm('#'+formID);
			}
		};
		
		MyWindow.load("automation", data, options);
		
		
	},
	
	updateParams : function(){
		var val = $('#auto_relatedtype').val();
		
		$('#automationParams .paramset').hide();

		if(val != ''){
			$('#automationParams #automation_'+val).show();
			$('#automationParams .placeholder:visible').hide();
			
			MyFacture.customForm('#automation_'+val);
			if(val == 'opportunity'){
				Automation.changeOppStep();
			}
		}else{
			$('#automationParams .placeholder:hidden').show();
		}
	},
	
	changeOppStep : function(){
		var option = $('#auto_opp_step').find('option:selected');
		
		$('#auto_opp_funnel').val(option.data('funnel'));
		$('#auto_opp_proba').val(option.data('proba'));
	},
		
	deleteOne : function(automationID){
		
		var options = {
			title :  Loc.g('Suppression d‘une action automatique'),
			type : 'warning',
			width : 450,
			buttons: [
				{
					"class" : "btn btn-default",
					text: Loc.g("Non"), 
					click: function() {
						$(this).dialog("close");
					}
				},
				{
					"class" : "btn btn-primary",
					text: Loc.g("Oui"), 
					click: function() {
						MyFacture.post('automation', {action:'delete', automationID : automationID},
						function(data){
							MyWindow.close('alertWindow');

							if(data.status == 'ok'){
								$('#automation_'+automationID).remove();
							}else{
								MyWindow.alert(data.message, {type : 'warning'});
							}
						}, 'json');
					}
				}
			]
		};
		
		MyWindow.alert(Loc.g('Voulez-vous vraiment supprimer l‘action automatique'), options);		
	},

	stepHasAutomationOnStepEnter : function(funnelid, stepid){

		var stepHasAutomationOnStepEnter = false;

		$.ajax({
			url 	: '/?_f=prospection_listing',
			type	: 'POST',
			data	: {
				action 		: 'stepHasAutomationOnStepEnter',
				funnelid 	: funnelid,
				stepid 		: stepid
			},
			dataType: 'json',
			async	: false,
			success : function(data){
				stepHasAutomationOnStepEnter = data[0];
			}
		});

		return stepHasAutomationOnStepEnter;

    },
    
    disabledExpediteurSelect: function (el, idElStaffSendId) {
        var valueSelect = el.val();
        var expediteur = $('#'+idElStaffSendId);
        if (valueSelect == 'specificStaff'){
            expediteur.prop('disabled', false);
        } else{
            expediteur.val(0);
            expediteur.prop('disabled', 'disabled');
        }
    }
};

